/*
    1. 判断是否登录【20行】
    2. 判断store中是否已存储
        2.1. store中已存储【23行】
            2.1.1. 是注册译员：不能进入完善信息页面-->> 重定向到译员首页【28行】， 系统进入译员首页且是译员，则走next()【30行】
            2.1.2. 非注册译员，只能进入完善信息页面-->> 重定向到完善信息页面【39行】， 系统进入完善信息页面且非译员，则走next()【37行】
        2.2. store中未存储【44行】
            2.2.1. 获取译员状态，存储到store中【47行】。而后：重新进入当前请求路由->【49行】：重新走一遍本文件程序

     2020.11.27 11:15 by zhanghaoran.
 */


import router from "./index";
import store from "../store/index"
import {getToken, removeToken} from "../utils/auth";


const whiteList = ["/improve_information/"];


router.beforeEach(async (to, from, next) => {

    if (to.meta.title == "error page") {
        next();
        return
    }
    if(to.meta.pageName){
        store.commit("changePageTitle", to.name)
    }
    if (to.meta.title) document.title = to.meta.title;


    // 判断是否已经登录,
    const hasToken = getToken();
    if(hasToken){
        const isInterpreter = store.getters.isInterpreter;

        if(isInterpreter){
            // store 存储了
            // 是注册译员，不能进入完善信息页面
            if(isInterpreter == 'yes'){
                if(whiteList.indexOf(to.path)>-1){
                    next("/translator")
                }else {
                    next()
                }
            }

            // 不是注册译员， 只能进入完善信息页面
            if(isInterpreter == "no"){
                if(whiteList.indexOf(to.path)>-1){
                    next()
                }else{
                    next("/improve_information/")
                    document.title = "完善信息"
                    store.commit("changePageTitle","improve_information")
                }
            }
        }else if(!isInterpreter){
            // store中没存储
            try{
                const {status} = await store.dispatch('permission/getIsInterpreter')
                if(status){
                    next({...to,replace: true})
                }else{
                    next("/improve_information/");
                    document.title = "完善信息";
                    store.commit("changePageTitle","improve_information")
                }
            }catch (e) {
                // 出错需要重置令牌并重新登陆(令牌过期,网络错误等原因)
                console.log(e)
            }
        }
    }else {
        removeToken()
    }

})